<template>
    <div>
        <div class="row form-group">
            <label class="col-md-2 control-label" for="commission_type">Commission Type</label>
            <div class="col-md-3">
                <select class="form-control" name="commission_type" id="commission_type" @change="onChange($event)" v-model="selected">
                    <option disabled value="">--Please Select One--</option>
                    <option value="percent" >Percentage</option>
                    <option value="fixed">Fixed Amount</option>
                </select>
            </div>
            <modal-help>
                Select the commission type first and then enter the amount or percentage below.
            </modal-help>
        </div>
        <div class="row form-group">
            <label class="col-md-2 control-label" for="commission_percentage">{{ newTitle }}</label>
            <modal-help>
                If commission type is percentage enter a number from 0 to 100.
                If commission type is fixed amount then enter a dollar value like 25.
                You can use two decimal places for both eg 25.75.
            </modal-help>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon">{{ addOn }}</span>
                    <input type="text" class="form-control" name="commission_percentage" id="commission_percentage" v-model="inputAmount"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ModalHelp from "./ModalHelp";
	export default {
		components: {
		    ModalHelp
        },
        props: [
            'commType',
            'commAmount'
        ],
		data() {
			return {
				selected: this.commType,
                inputAmount: this.commAmount,
                title: 'Commission',
                titlePercent: 'Percent',
                titleFixedAmount: 'Amount'
			}
		},
		computed: {
            newTitle() {
				if(this.selected === '') return this.title;
            	if(this.selected === 'percent' || this.commType === 'percent') return this.title + ' ' + this.titlePercent;
				if(this.selected === 'fixed') return this.title + ' ' + this.titleFixedAmount;
            },
            addOn() {
            	if(this.selected === 'percent') return '%';
            	if(this.selected === 'fixed') return '$';
            	if(this.selected === '') return '';
            }
        },
        methods: {
			onChange(event) {
				this.commType = event.target.value;
            }
        }
	}
</script>

<style scoped>

</style>